import { render, staticRenderFns } from "./BrowseGaiyo.vue?vue&type=template&id=0190cb12&scoped=true&"
import script from "./BrowseGaiyo.vue?vue&type=script&lang=js&"
export * from "./BrowseGaiyo.vue?vue&type=script&lang=js&"
import style0 from "./BrowseGaiyo.vue?vue&type=style&index=0&id=0190cb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190cb12",
  null
  
)

export default component.exports